/**
 * External dependencies.
 */
import { has, isEmpty } from 'lodash';

/**
 * Internal dependencies.
 */

const styling = ( { attributes, name }, selector = '' ) => {
	const { blockClientId, blockAdvanceOptions } = attributes;
	selector = selector ? selector : `.gutenify-section-${ blockClientId }`;
	if ( 'gutenify/button' === name ) {
		selector = `.gutenify-section-${ blockClientId } .gutenify-button-link`;
	}

	let css = '';

	let spacingDesktop = '';

	// Padding
	spacingDesktop += `${ has( blockAdvanceOptions, `padding.desktop.top` ) && ! isEmpty( blockAdvanceOptions.padding.desktop.top ) ? `padding-top: ${ blockAdvanceOptions.padding.desktop.top };` : '' }`;
	spacingDesktop += `${ has( blockAdvanceOptions, `padding.desktop.right` ) && ! isEmpty( blockAdvanceOptions.padding.desktop.right ) ? `padding-right: ${ blockAdvanceOptions.padding.desktop.right };` : '' }`;
	spacingDesktop += `${ has( blockAdvanceOptions, `padding.desktop.bottom` ) && ! isEmpty( blockAdvanceOptions.padding.desktop.bottom ) ? `padding-bottom: ${ blockAdvanceOptions.padding.desktop.bottom };` : '' }`;
	spacingDesktop += `${ has( blockAdvanceOptions, `padding.desktop.left` ) && ! isEmpty( blockAdvanceOptions.padding.desktop.left ) ? `padding-left: ${ blockAdvanceOptions.padding.desktop.left };` : '' }`;

	// Margin
	spacingDesktop += `${ has( blockAdvanceOptions, `margin.desktop.top` ) && ! isEmpty( blockAdvanceOptions.margin.desktop.top ) ? `margin-top: ${ blockAdvanceOptions.margin.desktop.top };` : '' }`;
	spacingDesktop += `${ has( blockAdvanceOptions, `margin.desktop.right` ) && ! isEmpty( blockAdvanceOptions.margin.desktop.right ) ? `margin-right: ${ blockAdvanceOptions.margin.desktop.right };` : '' }`;
	spacingDesktop += `${ has( blockAdvanceOptions, `margin.desktop.bottom` ) && ! isEmpty( blockAdvanceOptions.margin.desktop.bottom ) ? `margin-bottom: ${ blockAdvanceOptions.margin.desktop.bottom };` : '' }`;
	spacingDesktop += `${ has( blockAdvanceOptions, `margin.desktop.left` ) && ! isEmpty( blockAdvanceOptions.margin.desktop.left ) ? `margin-left: ${ blockAdvanceOptions.margin.desktop.left };` : '' }`;

	// Desktop
	if ( spacingDesktop ) {
		css += `${ selector } { ${ spacingDesktop } }`;
	}

	let spacingTablet = '';

	// Padding
	spacingTablet += `${ has( blockAdvanceOptions, `padding.tablet.top` ) && ! isEmpty( blockAdvanceOptions.padding.tablet.top ) ? `padding-top: ${ blockAdvanceOptions.padding.tablet.top };` : '' }`;
	spacingTablet += `${ has( blockAdvanceOptions, `padding.tablet.right` ) && ! isEmpty( blockAdvanceOptions.padding.tablet.right ) ? `padding-right: ${ blockAdvanceOptions.padding.tablet.right };` : '' }`;
	spacingTablet += `${ has( blockAdvanceOptions, `padding.tablet.bottom` ) && ! isEmpty( blockAdvanceOptions.padding.tablet.bottom ) ? `padding-bottom: ${ blockAdvanceOptions.padding.tablet.bottom };` : '' }`;
	spacingTablet += `${ has( blockAdvanceOptions, `padding.tablet.left` ) && ! isEmpty( blockAdvanceOptions.padding.tablet.left ) ? `padding-left: ${ blockAdvanceOptions.padding.tablet.left };` : '' }`;

	// Margin
	spacingTablet += `${ has( blockAdvanceOptions, `margin.tablet.top` ) && ! isEmpty( blockAdvanceOptions.margin.tablet.top ) ? `margin-top: ${ blockAdvanceOptions.margin.tablet.top };` : '' }`;
	spacingTablet += `${ has( blockAdvanceOptions, `margin.tablet.right` ) && ! isEmpty( blockAdvanceOptions.margin.tablet.right ) ? `margin-right: ${ blockAdvanceOptions.margin.tablet.right };` : '' }`;
	spacingTablet += `${ has( blockAdvanceOptions, `margin.tablet.bottom` ) && ! isEmpty( blockAdvanceOptions.margin.tablet.bottom ) ? `margin-bottom: ${ blockAdvanceOptions.margin.tablet.bottom };` : '' }`;
	spacingTablet += `${ has( blockAdvanceOptions, `margin.tablet.left` ) && ! isEmpty( blockAdvanceOptions.margin.tablet.left ) ? `margin-left: ${ blockAdvanceOptions.margin.tablet.left };` : '' }`;

	// tablet
	if ( spacingTablet ) {
		css += `@media only screen and (max-width: 992px) { ${ selector } { ${ spacingTablet } } }`;
	}

	let spacingMobile = '';

	// Padding
	spacingMobile += `${ has( blockAdvanceOptions, `padding.mobile.top` ) && ! isEmpty( blockAdvanceOptions.padding.mobile.top ) ? `padding-top: ${ blockAdvanceOptions.padding.mobile.top };` : '' }`;
	spacingMobile += `${ has( blockAdvanceOptions, `padding.mobile.right` ) && ! isEmpty( blockAdvanceOptions.padding.mobile.right ) ? `padding-right: ${ blockAdvanceOptions.padding.mobile.right };` : '' }`;
	spacingMobile += `${ has( blockAdvanceOptions, `padding.mobile.bottom` ) && ! isEmpty( blockAdvanceOptions.padding.mobile.bottom ) ? `padding-bottom: ${ blockAdvanceOptions.padding.mobile.bottom };` : '' }`;
	spacingMobile += `${ has( blockAdvanceOptions, `padding.mobile.left` ) && ! isEmpty( blockAdvanceOptions.padding.mobile.left ) ? `padding-left: ${ blockAdvanceOptions.padding.mobile.left };` : '' }`;

	// Margin
	spacingMobile += `${ has( blockAdvanceOptions, `margin.mobile.top` ) && ! isEmpty( blockAdvanceOptions.margin.mobile.top ) ? `margin-top: ${ blockAdvanceOptions.margin.mobile.top };` : '' }`;
	spacingMobile += `${ has( blockAdvanceOptions, `margin.mobile.right` ) && ! isEmpty( blockAdvanceOptions.margin.mobile.right ) ? `margin-right: ${ blockAdvanceOptions.margin.mobile.right };` : '' }`;
	spacingMobile += `${ has( blockAdvanceOptions, `margin.mobile.bottom` ) && ! isEmpty( blockAdvanceOptions.margin.mobile.bottom ) ? `margin-bottom: ${ blockAdvanceOptions.margin.mobile.bottom };` : '' }`;
	spacingMobile += `${ has( blockAdvanceOptions, `margin.mobile.left` ) && ! isEmpty( blockAdvanceOptions.margin.mobile.left ) ? `margin-left: ${ blockAdvanceOptions.margin.mobile.left };` : '' }`;

	// mobile
	if ( spacingMobile ) {
		css += `@media only screen and (max-width: 768px) { ${ selector } { ${ spacingMobile } } }`;
	}

	return css;
};

export default styling;
